import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class UploadLogs extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    getUploadlogs: PropTypes.func.isRequired,
    documents: PropTypes.object.isRequired,
  }
  componentDidMount() {
  }
  bannerProps = () => {
    const { routes, history, location, match, path } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const { routes, currentUser } = this.props
    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        {/* <BackToAdminCentre displayText={backToAdminCentreText} isAdmin={this.props.currentUser.IsAdmin} /> */}
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
            />
          ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({

})

export default withRouter(connect(mapStateToProps, {
})(UploadLogs))



// WEBPACK FOOTER //
// ./src/containers/UploadLogs.js